module.exports = __webpack_public_path__ + "assets/img/jeanne.80fa8e02.png";